<kp-screen-email-signup-base headerTitle="Verify Your Email Address">
  <div icon class="header-icon">
    <svg-icon src="/assets/icons/checkmark-empty-circle.svg"></svg-icon>
  </div>
  <div instructions class="instructions">
    <kp-user-email emailKey="unconfirmedEmail" (email)="getUserEmail($event)"></kp-user-email>
    <p class="instruction">
      Check your email and
      <strong>enter the 6-digit code</strong>
      you receive below.
    </p>
    <p class="instruction">This helps keep your account secure and makes sure you can get back into it later.</p>
  </div>
  <ng-container content>
    <form class="email-code-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)">
      <div class="sub-container">
        <label>
          <span class="form-label">
            Code
            <a class="code-show-help" routerLink="/welcome/signup/verification/no-code" [state]="{ email }">
              Didn't receive a code?
            </a>
          </span>
          <input
            class="code-input"
            type="tel"
            inputmode="number"
            maxlength="6"
            required
            formControlName="code"
            name="code"
            id="code"
            data-test="codeInput"
            (keydown)="handleKeydown($event)"
            (change)="codeChanged()"
            (input)="codeChanged()" />
        </label>
        <p class="error" *ngIf="formatError">
          <svg-icon src="/assets/icons/alert-circle.svg"></svg-icon>
          <span>The code you entered should be 6 digits.</span>
        </p>
        <p class="error" *ngIf="verifyError">
          <svg-icon src="/assets/icons/alert-circle.svg"></svg-icon>
          {{ errorMessage }}
        </p>
      </div>
      <button class="button button-pill button-submit" type="submit" [disabled]="!form?.valid || verifyError">
        Verify
      </button>
    </form>
  </ng-container>
  <ng-container footer>
    <p>Already have a Kumanu account?</p>
    <a routerLink="/login" class="button-text">Sign in</a>
  </ng-container>
</kp-screen-email-signup-base>
